// extracted by mini-css-extract-plugin
export var anchored = "component-module--anchored--9fead";
export var containerMediaText = "component-module--containerMediaText--dd5f7";
export var mediaTextButton = "component-module--mediaTextButton--dbf0c";
export var mediaTextButtonContainer = "component-module--mediaTextButtonContainer--bdffe";
export var mediaTextContentContainer = "component-module--mediaTextContentContainer--9e7fe";
export var mediaTextContentSection = "component-module--mediaTextContentSection--33213";